"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteBucketWebsiteInput = {
    type: "structure",
    required: ["Bucket"],
    members: {
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        }
    }
};
//# sourceMappingURL=DeleteBucketWebsiteInput.js.map